import Store from 'store/store';
import { pageName } from 'utils/copy';
import { copy } from 'utils/copy';

function getBaseUrl() {
	return Store.get().appData?.meta?.url || 'https://www.universalpictures.com';
}

export function getPageTitle(page) {
	return copy(`$META_TITLE_${page.id.toUpperCase()}`) || [
		pageName(page.id),
		copy('$SITE_NAME'),
	].filter(e => e).join(' | ');
}

export function getPageCanonicalLink(page) {
	let url = new URL(page.path, getBaseUrl());
	if (page.id === 'leadership' && typeof window !== 'undefined') {
		const qs = new URLSearchParams(window.location.search);
		if (qs.has('name')) {
			url.searchParams.set('name', qs.get('name'));
		}
	}
	return url.href;
}

export function getMetaData(appData, currentPage) {
	// Page title
	const title = getPageTitle(currentPage);
	const description = copy(`$META_DESCRIPTION_${currentPage.id.toUpperCase()}`) || copy('$META_DESCRIPTION');

	// Canonical URL and OG URL
	const url = getPageCanonicalLink(currentPage);

	// Image logic
	const image = new URL(`${__IMAGE_ROOT__}/share.jpg`, getBaseUrl()).href;

	let jsonSchema;
	if (currentPage.id === 'landing') {
		jsonSchema = {
			'@context': 'https://schema.org',
			'@type': 'website',
			name: copy('$SITE_NAME'),
			url,
		};
	}

	return {
		title,
		image,
		currentPage,
		url,
		description,
		elements: [
			{ name: 'description', content: description },
			{ name: 'twitter:title', content: title },
			{ name: 'twitter:image', content: image },
			{ name: 'google-site-verification', content: '_BWnI3vobObTPCauutH6jt2KKYDkuwMHtoyaV3M0H0Q' },
			{ property: 'og:title', content: title },
			{ property: 'og:site_name', content: copy('$SITE_NAME') },
			{ property: 'og:image', content: image },
			{ property: 'og:description', content: description },
			{ property: 'og:url', content: url },
		],
		socialLinks: Object.entries(appData?.meta?.social || {}).map(([name, url]) => ({ name, url })).filter(link => link.url),
		jsonSchema,
	};
}

export function getMovieMetaData({ title, releaseDate, releaseDateFormatted, url }) {
	// const isoDate = formatDateTime(releaseDate, 'yyyy-MM-dd');
	const description = copy('$META_DESCRIPTION_MOVIE_PAGE', { title, date: releaseDateFormatted });
	const fullTitle = copy('$META_TITLE_MOVIE_PAGE', { title }) || [title, copy('$SITE_NAME')].filter(e => e).join(' | ');
	const image = new URL(`${__IMAGE_ROOT__}/share.jpg`, getBaseUrl()).href;

	return {
		title: fullTitle,
		description,
		url,
		image,
		elements: [
			{ name: 'description', content: description },
			{ property: 'og:title', content: fullTitle },
			{ property: 'og:description', content: description },
			{ property: 'og:url', content: url },
			{ property: 'og:type', content: 'video.movie' },
			{ property: 'og:image', content: image }
			// Twitter tags intentionally omitted
		],
		jsonSchema: {
			'@context': 'https://schema.org',
			'@type': 'Movie',
			url,
			name: title,
			image: image,
			dateCreated: releaseDate,
			description,
			releasedEvent: {
				'@type': 'PublicationEvent',
				location: {
					'@type': 'Country',
					name: __REGION__.toUpperCase()
				},
				startDate: releaseDate
			}
		}
	};
}